export const processesColumns = [
  {
    title: 'Process',
    dataIndex: 'process',
    key: 'process',
    width: '70%',
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    width: '30%',
  },
];

export const similarStepsColumns = [
  {
    title: 'Step',
    dataIndex: 'step',
    key: 'step',
    width: '20%',
  },
  {
    title: 'Must Complete',
    dataIndex: 'stepMustCompleted',
    key: 'stepMustCompleted',
    width: '35%',
  },
  {
    title: 'Not Complete',
    dataIndex: 'stepNotBeCompleted',
    key: 'stepNotBeCompleted',
    width: '35%',
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    width: '10%',
  },
];
